// RIGHT EXERCISE TYPE
export const GET_RIGHT_EXERCISE_TYPES = '/right_exercise_type/query';
export const GET_RIGHT_EXERCISE_TYPE = '/right_exercise_type/';
export const POST_RIGHT_EXERCISE_TYPE = '/right_exercise_type/';
export const PUT_RIGHT_EXERCISE_TYPE = '/right_exercise_type/';
export const DELETE_RIGHT_EXERCISE_TYPE = '/right_exercise_type/';
export const CHECK_RIGHT_EXERCISE_TYPE_EXISTS = '/right_exercise_type/query';
